"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    T_PLUS_240_M: 240, //  240 min = 4 hrs
};
